'use client'

import { CxpContactForm } from '@/components/common/cxp/cxp-contact-form'
import {
  ParsedContent,
  ShortcodeContent,
  ShortcodeName,
} from '@/lib/helpers/shortcode-parser'
import { Product } from '@/types/product'
import { ProductGrid } from '../../shortcodes/product-grid'

interface ShortcodeProps {
  [key: string]: unknown
}

function InfoBox(props: ShortcodeProps) {
  const title = typeof props.title === 'string' ? props.title : undefined
  const content = typeof props.content === 'string' ? props.content : ''
  return (
    <div className='info-box border-l-4 border-blue-500 bg-blue-50 p-4'>
      {title && <h3 className='text-lg font-bold'>{title}</h3>}
      <div dangerouslySetInnerHTML={{ __html: content }} />
    </div>
  )
}

const CxpContactFormShortcode = () => {
  return (
    <div className='mx-auto max-w-[370px] md:max-w-[500px]'>
      <CxpContactForm />
    </div>
  )
}

// A mapping from shortcode names to React components
const shortcodeComponentMap: Record<ShortcodeName, React.FC<ShortcodeProps>> = {
  formcxp: CxpContactFormShortcode,
  collectionpreview: (props) => (
    <ProductGrid
      products={props.products as Product[]}
      title={props.title as string | undefined}
    />
  ),
  productpreview_grid: (props) => (
    <ProductGrid
      products={props.products as Product[]}
      title={props.title as string | undefined}
    />
  ),
  infobox: InfoBox,
  // Add other shortcode components here
  // Fallback for unimplemented shortcodes
  productpreview: () => <div>Product Preview (Not Implemented)</div>,
  productpreview_list: () => <div>Product Preview List (Not Implemented)</div>,
  productpreorder: () => <div>Product Pre-order (Not Implemented)</div>,
  productorderform: () => <div>Product Order Form (Not Implemented)</div>,
  timeline: () => <div>Timeline (Not Implemented)</div>,
  productpreorderpicksize: () => (
    <div>Product Pre-order Pick Size (Not Implemented)</div>
  ),
  productpreorderpicksizehascolor: () => (
    <div>Product Pre-order Pick Size w/ Color (Not Implemented)</div>
  ),
  couponcode: () => <div>Coupon Code (Not Implemented)</div>,
}

function RenderShortcode({ shortcode }: { shortcode: ShortcodeContent }) {
  const Component = shortcodeComponentMap[shortcode.name]

  if (!Component) {
    // Optionally return a placeholder or null for unsupported shortcodes
    return (
      <div className='text-red-500'>
        [Shortcode `{shortcode.name}` not supported]
      </div>
    )
  }

  return <Component {...shortcode.props} />
}

export function ShortcodeRenderer({ content }: { content: ParsedContent[] }) {
  return (
    <div>
      {content.map((item) => {
        if (item.type === 'html') {
          return (
            <div
              key={item.id}
              dangerouslySetInnerHTML={{ __html: item.content }}
            />
          )
        }
        if (item.type === 'shortcode') {
          return <RenderShortcode key={item.id} shortcode={item} />
        }
        return null
      })}
    </div>
  )
}
